<template>
  <div>
    <Header :ifbluein="ifbluein"></Header>
    <breadcrumb :secondhref="secondhref" :secondtest="secondtest" :thirdhref="thirdhref" :thirdtest="thirdtest"></breadcrumb>
    <div class="content-body body-box" style="overflow: hidden">
      <div class="main-item">
        <div class="body-left">
          <div class="test-box">
            <div class="test-head">
              <span v-for="(c,index) in cate" ref="Constitution" :key="index" :id="c.id" :class="{'test-title-on':c.id===ifSelection,'test-title-off':c.id!==ifSelection}" @click="viceNavigation($event)">{{c.title}}</span>
            </div>
          </div>
          <div style="background-color: #ffffff;">
            <div style="text-align: left;padding: 25px;font-size: 14px;" v-html="text">
            </div>
          </div>
        </div>
        <!--<div class="body-right">
          <contact></contact>
        </div>-->
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Footer from '@/components/footer/footer.vue'
import Header from '@/components/header/header.vue'
import breadcrumb from '@/components/breadcrumb/breadcrumb.vue'
import contact from '@/components/contact/contact.vue'
import HttpServer from '@/utils' // 接口请求
import '../../node_modules/bootstrap/dist/js/bootstrap.js'

export default {
  name: 'homet',
  data () {
    return {
      // 所在页面的名称
      topName: 'introduce',
      // 顶部导航栏
      ifbluein: {
        color: '#0051bd'
      },
      // 副导航栏
      ifSelection: 0,
      // 面包屑导航栏
      secondhref: '/introduce',
      thirdhref: '/introduce',
      secondtest: '学会介绍',
      thirdtest: '',
      // 副导航栏信息
      cate: [],
      // 文章内容(html)
      text: ''
    }
  },
  components: {
    Footer: Footer,
    Header: Header,
    breadcrumb: breadcrumb,
    contact: contact
  },
  methods: {
    // 副导航栏
    viceNavigation (event) {
      this.ifSelection = +event.target.id
      HttpServer.get('http://ysw.861718.com/gdics.php/index?act=' + this.topName + '&cateid=' + this.ifSelection).then(res => {
        this.text = res.data
        this.cate = res.cate
      })
    }
  },
  mounted () {
    // 调用本页接口
    HttpServer.get('http://ysw.861718.com/gdics.php/index?act=' + this.topName).then(res => {
      console.log(res)
      this.text = res.data
      this.cate = res.cate
      this.ifSelection = res.cate[0].id
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  @import '../../node_modules/bootstrap/dist/css/bootstrap.css';
  @import 'joinprocess/main.css';
  .body-box{
    margin-top:10px;
    background-color: #f5f5f5;
  }
  .body-left{
    width: 950px;
    float: left;
  }
  .body-right{
    width: 200px;
    float: right;
  }
  .test-box{
    min-height: 0px !important;
    padding: 12px;
    background-color: #ffffff;
    font-size: 12px;
    text-align: left;
  }
  .test-head{
    height:30px;
    margin-bottom: 15px;
    border-bottom: 1px solid #d7d7d7;
  }
  .test-title-on{
    font-size: 14px;
    margin: 0px 5px;
    cursor:pointer;
    color: #0051bd;
  }
  .test-title-off{
    font-size: 14px;
    margin: 0px 5px;
    cursor:pointer;
    color: #000000;
  }
</style>



// WEBPACK FOOTER //
// src/components/introduce.vue